type LexicalNode = {
  type: string
  text?: string
  children?: LexicalNode[]
}

type LexicalContent = {
  root?: LexicalNode
}

function hasText(node: LexicalNode): boolean {
  if (node.type === 'text') {
    return typeof node.text === 'string' && node.text.trim() !== ''
  }
  if (Array.isArray(node.children)) {
    return node.children.some(hasText)
  }
  return false
}

/**
 * 判断 @payloadcms/richtext-lexical 的富文本对象是否为空（无任何可见文字内容）
 */
export function isLexicalEmpty(content: LexicalContent | string | null | undefined): boolean {
  if (!content) return true
  if (typeof content === 'string') return content.trim() === ''

  const root = content?.root
  if (!root) return true

  return !hasText(root)
}
